import { config } from '@app/config';

export type McpEnvironment = 'dev' | 'stage' | 'prod';

// Окружение MCP задаёт режим сборки CRM (MODE из .env.*), а не адрес
// страницы или CRM API.
export const getMcpEnvironment = (): McpEnvironment | null => {
  const { mode } = config;

  if (mode === 'development') {
    return 'dev';
  }

  if (mode === 'staging') {
    return 'stage';
  }

  if (mode === 'production') {
    return 'prod';
  }

  return null;
};
